import gsap from 'gsap';
const Fadein = {
  scroll() {
    const els = document.querySelectorAll<HTMLElement>('.c-fadein:not(.is-inview)');
    if (els.length) {
      els.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 0.5) {
          el.classList.add('is-inview');
          if (el.hasAttribute('data-fade-up')) {
            gsap
              .timeline()
              .to(el, {
                duration: 1.8,
                autoAlpha: 1,
              })
              .to(
                el,
                {
                  duration: 1,
                  y: 0,
                },
                '=',
              );
          } else {
            gsap.to(el, {
              duration: 1.8,
              autoAlpha: 1,
            });
          }
        }
      });
    }
  },
};
export { Fadein };
